import { useUpdateItem } from "./items";

export function useCreationHistory(
    history_id,
    onSuccess = () => {},
    onDone = () => {}
) {
    const mutation = useUpdateItem(
        "qdb_creation_history",
        history_id,
        onSuccess,
        onDone
    );

    function addTemplateInHistory(template_id) {
        mutation.mutate({
            design_template: template_id,
        });
    }

    return {
        isLoading: mutation.isLoading,
        addTemplateInHistory,
    };
}
